<template>
	<div>
		<el-form :model="line" :rules="rules" style="text-align:left" label-position="right" label-width="180px" ref="line"  size="small" >
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="申请编号" prop="name" >
							<input type="hidden" v-model="line.id" readonly/>
							<input type="hidden" v-model="line.userId" readonly/>
							<el-input v-model="line.applyId" readonly auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="公司名称" prop="companyName">
							<el-input v-model="line.companyName"  auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="线路负责人" prop="lineRealName">
							<el-input  v-model="line.lineRealName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="线路负责人电话" prop="lineTelephone">
							<el-input v-model="line.lineTelephone"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<hr>
				<el-row  :gutter="2">
					<el-col :span="12">
						<el-form-item label="始发站联系人" prop="startRealName">
							<el-input  v-model="line.startRealName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="始发站联系人电话" prop="startTelephone">
							<el-input  v-model="line.startTelephone"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="始发站地址" prop="startAddress">
							<el-input  v-model="line.startAddress"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="始发站地址经度" prop="startLongitude">
							<el-input  v-model="line.startLongitude"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="始发站地址纬度" prop="startLatitude">
							<el-input  v-model="line.startLatitude"></el-input>
						</el-form-item>
					</el-col>
					
				</el-row>
				<hr>
				<el-row  :gutter="2">
					<el-col :span="12">
						<el-form-item label="到达站" prop="endStand">
							<el-input  v-model="line.endStand"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="到达站联系人" prop="endRealName">
							<el-input  v-model="line.endRealName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="到达站联系人电话" prop="endTelephone">
							<el-input  v-model="line.endTelephone"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="到达站地址" prop="endAddress">
							<el-input  v-model="line.endAddress"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="到达站经度" prop="endLongitude">
							<el-input  v-model="line.endLongitude"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="到达站维度" prop="endLatitude">
							<el-input  v-model="line.endLatitude"></el-input>
						</el-form-item>
					</el-col>

				</el-row>
				
				<!-- <el-form-item label="轮播图">
					<el-upload
					  class="upload-demo"
					  multiple
					  list-type="picture-card"
					  action="/api/img/upload"
					  :on-remove="handleRemove"
					  :on-success="handleAvatarSuccess"
					  :file-list="imgFiles"
					  >
					  <el-button size="small" type="primary">点击上传</el-button>
					  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
					</el-upload>

				</el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="backToLisk">返回</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
	</div>
</template>
<script>
	import {auditApplyToLine} from '@/api/api.js'
	import tools from "@/tools"
	export default {
		data(){
			return {
				line:{
					id:null,
					applyId:null,
					userId:null,
					companyName:"",
					lineRealName:"",
					lineTelephone:"",
					midStand:"",
					startRealName:"",
					startAddress:"",
					startLongitude:"",
					startLatitude:"",
					startTelephone:"",
					endRealName:"",
					endAddress:"",
					endLongitude:"",
					endLatitude:"",
					endTelephone:"",
					endStand:"",
					imgs:[]
				},
				rules: {
		          companyName: [
		            { required: true, message: '请输入公司名称', trigger: 'blur' }
		          ],
		          lineRealName: [
		            { required: true, message: '请输入联系人姓名', trigger: 'blur' }
		          ],
		          lineTelephone: [
		            { required: true, message: '请输入线路负责人电话', trigger: 'blur' }
		          ],
		          startRealName: [
		            { required: true,  message: '请输入出发站联系人', trigger: 'blur' }
		          ],
		          startAddress: [
		            { required: true,  message: '请输入出发站地址', trigger: 'blur' }
		          ],
		          startLongitude: [
		            { required: true,  message: '请输入出发站经度', trigger: 'blur' }
		          ],
		          startLatitude: [
		            { required: true,  message: '请输入出发站纬度', trigger: 'blur' }
		          ],
		          startTelephone: [
		            { required: true,  message: '请输入出发站联系人电话', trigger: 'blur' }
		          ],
		          endRealName: [
		            { required: true,  message: '请输入到达站联系人', trigger: 'blur' }
		          ],
		          endAddress: [
		            { required: true,  message: '请输入到达站地址', trigger: 'blur' }
		          ],
		          endLongitude: [
		            { required: true,  message: '请输入到达站经度', trigger: 'blur' }
		          ],
		          endLatitude: [
		            { required: true,  message: '请输入到达站纬度', trigger: 'blur' }
		          ],
		          endTelephone: [
		            { required: true,  message: '请输入到达站联系人电话', trigger: 'blur' }
		          ],
		          endStand: [
		            { required: true,  message: '请输入到达站', trigger: 'blur' }
		          ]
		        },
 
				imgFiles:[],
				addLoading:false
			}

		},
		created:function() {
			var _this = this;
			let apply = this.$route.params;
			this.line.applyId = apply.id;
			this.line.userId = apply.userId;
			this.line.companyName = apply.companyName;
		},
		methods:{
			addSubmit(){
				this.$refs["line"].validate((valid)=>{
					if(valid){
						auditApplyToLine(this.line).then(res=>{
							if(res.data.status=="success"){
								this.$message('添加成功');
								this.addLoading=false;
								this.$router.go(-1);
							}
						});	
					}	
				});
			},
			handleAvatarSuccess(res, file,fileList) {
				if(this.line.imgs){
					this.line.imgs.push(res.data);
				}else{
					this.line.imgs = []
					this.line.imgs.push(res.data);
				}
		    },
		    handleRemove(file, fileList){
		    	tools.arrayRemove(this.line.imgs,file.response.data);
		    },
		    backToLisk(){
		    	this.$router.go(-1);
		    }
		}
	}
</script>